import {
    MdCheckCircle,
    MdEmergency,
    MdError,
    MdHelpOutline,
    MdPowerOff,
    MdShield,
    MdWarning
} from 'react-icons/md';

export const statusLegend = [
    { icon: MdPowerOff, name: 'Offline', id: 10, color: '#808080', twColor: 'bg-gray-500' },
    { icon: MdCheckCircle, name: 'Running', id: 20, color: '#00FF00', twColor: 'bg-emerald-500' },
    { icon: MdShield, name: 'Guarded', id: 30, color: '#4B9BFF', twColor: 'bg-blue-500' },
    { icon: MdWarning, name: 'Elevated', id: 40, color: '#FFD700', twColor: 'bg-amber-500' },
    { icon: MdError, name: 'Alert', id: 50, color: '#FF8C00', twColor: 'bg-orange-500' },
    { icon: MdEmergency, name: 'Emergency', id: 60, color: '#FF0000', twColor: 'bg-red-500' },
    { icon: MdHelpOutline, name: 'Unknown', id: 0, color: '#CCCCCC', twColor: 'bg-gray-400' }
];

export const getStatusDetails = (statusId: number | string) => {
    const id = Number(statusId);
    return statusLegend.find(item => item.id === id) || statusLegend.find(item => item.name === 'Unknown');
}; 